



























import CommonDialog from '../../components/organisms/CommonDialog.vue';
import { Vue, Component, Prop } from 'vue-property-decorator';
import FileAttach from '../fileattach/FileAttach.vue';
import { MessageDialog } from '../../utils/MessageDialog';
import { DailyReportServiceExt } from '../../biz/DailyReportServiceExt';
import { Session } from '../../utils/Session';
import { ReportDTO } from '../../../src_server/entity/dto/ReportDTO';
import { FileHandler, FileAndUrl } from '../fileattach/FileHandler';

@Component({ components: { CommonDialog, FileAttach } })
export default class FileAddDialog extends Vue {
  private attachedFiles: FileAndUrl[] = [];
  private dto: ReportDTO = new ReportDTO();
  private newComment = '';
  private class_id = 0;

  public async show(dto: ReportDTO) {
    this.dto = dto;
    this.class_id = dto.lessons.class_id || 0;
    (this.$refs['fileDialog'] as CommonDialog).show();
  }

  public close() {
    (this.$refs['fileDialog'] as CommonDialog).hide();
  }

  addFile(file: FileAndUrl) {
    this.attachedFiles.push(file);
  }

  delFile(index: number) {
    console.log('del ', index);
    this.attachedFiles.splice(index);
  }

  /**
   * 日報コメントの送信
   */
  async sendComment() {
    if (!this.dto.lessons.class_id) {
      MessageDialog.systemError('レッスンID', 'コメント送信', this.dto.lessons.class_id).then();
      return;
    }
    if (!this.dto.lessons.start_dt) {
      MessageDialog.systemError('レッスン日時', 'コメント送信', this.dto.lessons.start_dt).then();
      return;
    }

    const isOk = await MessageDialog.confirm('コメントを保存し通知を実施します。よろしいですか。');
    if (isOk) {
      const biz = new DailyReportServiceExt();

      // 先生への返信が基本、同一UserIDだったら相手の生徒に通知
      let toUserId = this.dto.lessons.teacher_user_id || '';
      const fromUserId = Session.getSessionUserId();
      if (this.dto.lessons.teacher_user_id === fromUserId) {
        toUserId = this.dto.lessons.student_user_id || '';
      }

      // ファイルをアップロード
      const fileNames = await FileHandler.fileAttachUpload(fromUserId, this.attachedFiles);

      // コメントして通知
      const lessonDate = this.dto.lessons.start_dt;
      await biz.addComment(this.dto.lessons.class_id, fromUserId, toUserId, this.newComment, lessonDate, fileNames, Session.getSessionBuildingId());
      await this.loadReport();

      // リセット
      this.attachedFiles = [];
      this.newComment = '';
      this.$emit('added');
      this.close();
    }
  }

  async loadReport() {
    const class_id_param = this.$route.query.class_id as string;
    if (!class_id_param) {
      MessageDialog.systemError('レッスンID', '日報表示時', class_id_param).then();
      return;
    }
    // 引数は文字列になっているので数値化
    this.class_id = parseInt(class_id_param);

    // 日報データを取得
    const biz = new DailyReportServiceExt();
    const resonse = await biz.getReportForInput(this.class_id, Session.getSessionUserId());
    if (resonse.hasError) {
      await MessageDialog.systemError('日報', '日報表示時', resonse.data);
      return;
    }
    this.dto = resonse.data;
  }
}
